import React, { createContext, useContext, useState, useEffect } from 'react';
import { productsApi } from '../services/api';

const ProductContext = createContext();

export const useProduct = () => {
  const ctx = useContext(ProductContext);
  if (!ctx) throw new Error('useProduct must be used within ProductProvider');
  return ctx;
};

const STORAGE_KEY = 'selectedProductFilter';

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  // selectedProduct value: 'all' | 'unassigned' | <product_id>
  const [selectedProduct, setSelectedProductState] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || 'all';
  });
  const [loading, setLoading] = useState(false);

  const setSelectedProduct = (value) => {
    setSelectedProductState(value);
    localStorage.setItem(STORAGE_KEY, value);
  };

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const res = await productsApi.list();
      setProducts(res.data || []);
    } catch (e) {
      console.error('Failed to fetch products', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // Resolve a productId param ready to be passed to backend queries
  const productIdParam = () => {
    if (selectedProduct === 'all') return undefined;
    return selectedProduct;
  };

  const selectedProductObject = products.find(p => p.id === selectedProduct) || null;

  return (
    <ProductContext.Provider
      value={{
        products,
        selectedProduct,
        setSelectedProduct,
        productIdParam,
        selectedProductObject,
        refreshProducts: fetchProducts,
        loading
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export default ProductContext;
